import { render, staticRenderFns } from "./CopyDataDialog.vue?vue&type=template&id=48231b15&scoped=true"
import script from "./CopyDataDialog.vue?vue&type=script&lang=js"
export * from "./CopyDataDialog.vue?vue&type=script&lang=js"
import style0 from "./CopyDataDialog.vue?vue&type=style&index=0&id=48231b15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48231b15",
  null
  
)

export default component.exports